module.exports = __webpack_public_path__ + "static/media/animator.97d95fc1.jpg";